<template>
  <n-message-provider>
    <n-loading-bar-provider>
      <router-view />
    </n-loading-bar-provider>
  </n-message-provider>
</template>
<style lang="scss">
@import "@/assets/sass/custom.scss";
</style>